export interface User {
  Username: string;
  Nome: string;
  Cognome: string;
  Email: string;
  Telefono1: string;
  TipoOperatore: TipoOperatore;
  PartitaIvaUdD: string;
  RagSocialeUdD: string;
  PartitaIvaDistribuzione: string;
}

export enum TipoOperatore {
  NORMALE = 'NORMALE',
  SUPER = 'SUPERUSER'
}

export interface UDDItem {
  Id: string;
  Codice: string;
  Descrizione: string;
  descrizioneBreve: string;
  CodiceRDB: string;
  CodiceUTF: string;
  CodiceSGI: string;
  RagioneSociale: string;
  PartitaIva: number;
  CodiceFiscale: string;
  CodiceInterno: string;
  PartitaIvaStr: string;
}
